module.exports = "<div data-ng-include=\"'template-cache/booking/edit.'+vm.viewMode+'.html'\"></div>\n";